import { useEffect, Fragment, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import validator from 'validator';
import axios from 'axios';
import Cookies from 'js-cookie';
import { Updateprofile } from '../Landing/Updateprofile';
import { HandleSurveyors } from "./HandleSurveyors";
import { GetSurveyors } from "./GetSurveyors";
import { ClientList } from "./ClientList";
import socket from 'socket.io-client';

const io = socket.connect('https://land-survey-main-server.onrender.com');

const AdminDash = () => {
const Navigate = useNavigate();

// Layout Responsiveness Toggle State
const [isSidebarMobileOpen, setIsSidebarMobileOpen] = useState(false);

// UI Toggle States
const [Profile, setProfile] = useState(false);
const [Show_add_form, setShow_add_form] = useState(false);
const [team, setTeam] = useState(false);
const [table, setTable] = useState(false);
const [client_open, setClint_open] = useState(false);
const [Newservice, setNewservice] = useState(false);
const [serviceRequests, setServiceRequests] = useState(false);
const [progressPanel, setProgressPanel] = useState(false); // New explicit view state flag
const [surveyorProgressUpdates, setSurveyorProgressUpdates] = useState([]); // Array for progress data

// Notification UI States
const [notifications, setNotifications] = useState([]);
const [showNotifDropdown, setShowNotifDropdown] = useState(false);
const [unreadCount, setUnreadCount] = useState(0);

// Client Management & Modal States
const [selectedClient, setSelectedClient] = useState(null);
const [view_client_modal, setViewClientModal] = useState(false);
const [clientFeedback, setClientFeedback] = useState('');

// Service Request States
const [requests, setRequests] = useState([]);
const [selectedRequest, setSelectedRequest] = useState(null);
const [viewRequestModal, setViewRequestModal] = useState(false);

// Admin Data States
const [admin_name, setName] = useState('');
const [admin_email, setEmail] = useState('');
const [admin_password, setPassword] = useState('');
const [admin_image, setImage] = useState('');
const [image, getImage] = useState('');
const [name, getName] = useState('Admin');
const [error, setError] = useState('');

// Surveyor/Team States
const [surveyor_name, setSurveyor_name] = useState('');
const [surveyor_email, setSurveyor_email] = useState('');
const [surveyor_password, setSurveyor_password] = useState('');
const [surveyor_phone, setSurveyor_phone] = useState('');
const [surveyor_image, setSurveyor_image] = useState('');
const [surveyor_error, setSurveyor_error] = useState('');
const [surveyor, setSurveyors] = useState([]);
const [clients, setClients] = useState([]);
const [chatHistoryClient, setchatHistoryClient] = useState([]);

const [selectedMember, setSelectedMember] = useState(null);
const [message, setMessage] = useState('');
const [chatHistory, setchartHistory] = useState([]);

// Handle services states
const [serviceName, setServiceName] = useState('');
const [description, setDescription] = useState('');
const [serviceImage, setServiceImage] = useState(null);
const [Questions, setQuestions] = useState([{
text: '',
type: 'Text',
options: [],
placeholder: '',
required: false
}]);

console.log(typeof requests);

const Filter_input = (value) => {
return validator.escape(value.trim().toLowerCase());
}

useEffect(() => {
const admin_token = Cookies.get('Admin_token');
if (!admin_token) {
Navigate('/login');
return;
}
io.emit('verify', admin_token);

io.on('surveyorMessage', ({ report, senderId }) => {
setchartHistory((prev) => [...prev, { report, sender: 'surveyor', time: new Date(), senderId }]);
});

io.on('client_message', ({ client_name, client_email, client_message, senderId }) => {
setchatHistoryClient((prev) => [...prev, { client_message, time: new Date(), senderId }]);
});

// Notification Listener
io.on('newNotification', (dataNotif) => {
console.log(dataNotif);
setNotifications((prev) => [...dataNotif, ...prev]);
setUnreadCount((prev) => prev + dataNotif.length);
});

io.on('token_expired', (data) => {
alert(data);
Cookies.remove('Admin_token');
Navigate('/login');
});

return () => {
io.off('newNotification');
io.off('verify');
io.off('surveyorMessage');
io.off('client_message');
io.off('token_expired');
};
}, [Navigate]);

const FetchData = async () => {
try {
const response = await axios.get('https://land-survey-main-server.onrender.com/admin');
if (response.data?.admin) {
getImage(response.data.admin.admin_image);
getName(response.data.admin.admin_name);
}
} catch (err) { console.error("Admin fetch error", err); }
}

const SurveyorsList = async () => {
const data = await GetSurveyors();
setSurveyors(data || []);
}

const ClientsList = async () => {
const data = await ClientList();
setClients(data || []);
}

const FetchServiceRequests = async () => {
try {
const response = await axios.get('https://land-survey-main-server.onrender.com/serviceRequests');
setRequests(response.data.requests);
} catch (err) { console.log(err); }
}

useEffect(() => {
FetchData();
SurveyorsList();
ClientsList();
FetchServiceRequests();
FetchSurveyorProgressUpdates();
}, []);

const FetchSurveyorProgressUpdates = async () => {
  try {
    const response = await axios.get('https://land-survey-main-server.onrender.com/surveyorProgress');
    console.log(response.data);
   if(response.data){
     if (!response.data.status) {
      alert(response.data.message);
    }

      if(response.data.status){
          setSurveyorProgressUpdates(response.data.progress);
          
    }
    
   }

  } catch (err) {
    console.error("Failed to read task progress datasets from server stack", err);
  }
}

const handleApproveProgress = async (progress_id) => {
  try {
    const response = await axios.post('https://land-survey-main-server.onrender.com/approveProgressToClient', {
     activityId: progress_id
    });
    
    if(response?.data?.status === false){
      alert(response.data.message);
    }

  if(response?.data?.status === true){
      alert(response.data.message);
    }

  } catch (err) {
    console.error(err);
  }
}

const handleDeleteProgressUpdate = async (progressId) => {
 if (!window.confirm("Delete this progress entry? The client will no longer see it.")) return;
  try {
  const response =  await axios.delete(`https://land-survey-main-server.onrender.com/deleteProgressUpdate`,{data: {progressId}});
  
    if(response?.data?.status === false){
      alert(response.data.message);
    }

  if(response?.data?.status === true){
      alert(response.data.message);
    }

  } catch (err) {
    console.log(err);
  }
  setSurveyorProgressUpdates((prev) => prev.filter(item => item.progress_id !== progressId));
}

const HandleUpdateprofile = (e) => {
e.preventDefault();
const data = { admin_name, admin_email, admin_password, admin_image };
const setter = { setError, getImage, getName, FetchData };
Updateprofile(data, setter);
}

const AddSurveyors = (e) => {
e.preventDefault();
const data = { surveyor_name, surveyor_email, surveyor_phone, surveyor_password, surveyor_image };
const setter = { setSurveyor_error, setSurveyors, Surveyors: SurveyorsList };
HandleSurveyors(data, setter);
}

const SendMessage = () => {
if (message === '') return alert('Type message in input field to send!');
io.on('ReceiverNotConnected',({message}) => {
alert(message);
});
setchartHistory((prev) => [...prev, { message, sender: 'admin', time: new Date(), surveyorId: selectedMember.member_id }])
io.emit('sendMessage', { toUserid: selectedMember.member_id, message });
setMessage('');
}

const sendFeedBack = () => {
if (!clientFeedback) return alert("Please enter feedback");
io.emit('send_message_to_client', {
receiverId: selectedClient.customer_id,
receiverName: selectedClient.customer_name,
receiverEmail: selectedClient.customer_email,
feedBack: clientFeedback
});
setClientFeedback('');
setViewClientModal(false);
alert("Feedback sent successfully!");
}

const handleLogout = () => {
if (window.confirm("Are you sure you want to logout?")) {
Cookies.remove('Admin_token');
Navigate('/login');
}
}

const DeleteSurveyor = async (surveyorInfo) => {
if (!window.confirm("Are you sure?")) return;
try {
const response = await axios.post('https://land-survey-main-server.onrender.com/deleteSurveyor', {
id: surveyorInfo.member_id,
name: surveyorInfo.member_name,
email: surveyorInfo.member_email,
});
if (response?.data?.message) {
alert(response.data.message);
setSurveyors((prev) => prev.filter(s => s.member_id !== surveyorInfo.member_id));
}
} catch (err) { console.log(err); }
}

const DeleteServiceRequest = async (submissionId) => {
if (!window.confirm("Are you sure you want to remove this service request?")) return;
try {
const response = await axios.post('https://land-survey-main-server.onrender.com/deleteServiceRequest', {
submissionId
});
console.log(submissionId);
if (response?.data?.message) {
alert(response.data.message);
}
setRequests((prev) => prev.filter(req => req.submission_id !== submissionId));
setViewRequestModal(false);
} catch (err) { 
console.log(err); 
alert("Failed to remove request.");
}
}

const AddNewQuestion = () => {
setQuestions([...Questions, {
text: '',
type: 'Text',
options: [],
placeholder: '',
required: false
}]);
}

const UpdateQuestions = (index, field, value, optIndex = null) => {
const updated = [...Questions];
if (field === "option") {
updated[index].options[optIndex] = value;
} else if (field === "addOption") {
updated[index].options.push("");
} else if (field === "removeOption") {
updated[index].options.splice(optIndex, 1);
} else {
updated[index][field] = value;
if (field === "type" && value !== "Option") {
updated[index].options = [];
}
}
setQuestions(updated);
}

const handleNotificationClick = (id) => {
 const userLink = clients.find(c => String(c.customer_id) === String(id));
 setNotifications(false);
 setServiceRequests(false); 
 setNewservice(false); 
 setClint_open(false); 
 setTable(false); 
 setProfile(false); 
 setShow_add_form(false);
 setProgressPanel(false); 
 setTeam(false);
 setClint_open(true);
 setSelectedClient(userLink);
 setViewClientModal(true);
}

const AddService = async () => {
const formData = new FormData();
formData.append('service_name', serviceName);
formData.append('description', description);
formData.append('service_image', serviceImage);
formData.append('formField', JSON.stringify(Questions));
try {
const response = await axios.post('https://land-survey-main-server.onrender.com/addService', formData);
if (response && response.data.message) {
alert(response.data.message);
}
} catch (err) {
console.log(err);
}
}

return (
<Fragment>
<div className="flex min-h-screen bg-[#f8fafc] font-sans antialiased text-slate-800">

{/* --- SIDEBAR CONTAINER --- */}
<div className={`w-72 fixed inset-y-0 left-0 bg-slate-900 z-30 flex flex-col justify-between p-6 transition-transform duration-300 ease-in-out border-r border-slate-800 shadow-xl lg:translate-x-0 ${isSidebarMobileOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`}>
<div>
<div className="flex items-center justify-between pb-6 mb-6 border-b border-slate-800">
<div className="flex items-center gap-3">
<div className="flex items-center justify-center text-xl font-bold text-white bg-blue-600 shadow-lg w-9 h-9 rounded-xl shadow-blue-500/20">A</div>
<span className="text-xl font-bold tracking-tight text-white">Console Admin</span>
</div>
<button onClick={() => setIsSidebarMobileOpen(false)} className="p-1 transition-colors rounded-lg text-slate-400 hover:bg-slate-800 hover:text-white lg:hidden">
<img src="images/menu3.png" className="w-5 h-5 invert brightness-200" alt="close menu" />
</button>
</div>

<div className="space-y-1.5">
<Link to='/' className="flex items-center gap-3 px-4 py-3 font-medium transition-all text-slate-300 rounded-xl hover:bg-slate-800 hover:text-white group" onClick={() => setIsSidebarMobileOpen(false)}>
<img src="/images/dashboard.png" className="w-5 h-5 transition-opacity opacity-70 group-hover:opacity-100 invert brightness-200" alt="dash" />
<span>Dashboard</span>
</Link>

<div className={`flex items-center px-4 py-3 rounded-xl cursor-pointer gap-3 transition-all group font-medium ${Profile ? 'bg-blue-600 text-white' : 'text-slate-300 hover:bg-slate-800 hover:text-white'}`} onClick={() => { setProgressPanel(false); setProfile(true); setShow_add_form(false); setTable(false); setTeam(false); setClint_open(false); setNewservice(false); setServiceRequests(false); setIsSidebarMobileOpen(false); }}>
<img src="/images/profile.png" className={`w-5 h-5 transition-opacity invert brightness-200 ${Profile ? 'opacity-100' : 'opacity-70 group-hover:opacity-100'}`} alt="profile" />
<span>Profile</span>
</div>

<div className={`flex items-center px-4 py-3 rounded-xl cursor-pointer gap-3 transition-all group font-medium ${table || Show_add_form ? 'bg-blue-600 text-white' : 'text-slate-300 hover:bg-slate-800 hover:text-white'}`} onClick={() => { setProgressPanel(false); setTable(true); setProfile(false); setShow_add_form(false); setTeam(false); setClint_open(false); setNewservice(false); setServiceRequests(false); setIsSidebarMobileOpen(false); }}>
<img src="/images/userManagement.png" className={`w-5 h-5 transition-opacity invert brightness-200 ${table || Show_add_form ? 'opacity-100' : 'opacity-70 group-hover:opacity-100'}`} alt="mgmt" />
<span>Surveyors</span>
</div>

<div className={`flex items-center px-4 py-3 rounded-xl cursor-pointer gap-3 transition-all group font-medium ${client_open ? 'bg-blue-600 text-white' : 'text-slate-300 hover:bg-slate-800 hover:text-white'}`} onClick={() => {setProgressPanel(false); setClint_open(true); setTable(false); setProfile(false); setShow_add_form(false); setTeam(false); setNewservice(false); setServiceRequests(false); setIsSidebarMobileOpen(false); }}>
<img src="/images/clientManagement.png" className={`w-5 h-5 transition-opacity invert brightness-200 ${client_open ? 'opacity-100' : 'opacity-70 group-hover:opacity-100'}`} alt="client" />
<span>Client Management</span>
</div>

<div className={`flex items-center px-4 py-3 rounded-xl cursor-pointer gap-3 transition-all group font-medium ${Newservice ? 'bg-blue-600 text-white' : 'text-slate-300 hover:bg-slate-800 hover:text-white'}`} onClick={() => { setProgressPanel(false); setNewservice(true); setClint_open(false); setTable(false); setProfile(false); setShow_add_form(false); setTeam(false); setServiceRequests(false); setIsSidebarMobileOpen(false); }}>
<img src="/images/serviceManagement.png" className={`w-5 h-5 transition-opacity invert brightness-200 ${Newservice ? 'opacity-100' : 'opacity-70 group-hover:opacity-100'}`} alt="service" />
<span>Service Management</span>
</div>

<div className={`flex items-center px-4 py-3 rounded-xl cursor-pointer gap-3 transition-all group font-medium ${serviceRequests ? 'bg-blue-600 text-white' : 'text-slate-300 hover:bg-slate-800 hover:text-white'}`} onClick={() => { setProgressPanel(false); setServiceRequests(true); setNewservice(false); setClint_open(false); setTable(false); setProfile(false); setShow_add_form(false); setTeam(false); FetchServiceRequests(); setIsSidebarMobileOpen(false); }}>
<img src="/images/servicerequest.png" className={`w-5 h-5 transition-opacity invert brightness-200 ${serviceRequests ? 'opacity-100' : 'opacity-70 group-hover:opacity-100'}`} alt="requests" />
<span>Service Requests</span>
</div>

<div className={`flex items-center px-4 py-3 rounded-xl cursor-pointer gap-3 transition-all group font-medium ${team ? 'bg-blue-600 text-white' : 'text-slate-300 hover:bg-slate-800 hover:text-white'}`} onClick={() => { setProgressPanel(false); setTeam(true); setTable(false); setProfile(false); setShow_add_form(false); setClint_open(false); setNewservice(false); setServiceRequests(false); setIsSidebarMobileOpen(false); }}>
<img src="/images/team.png" className={`w-5 h-5 transition-opacity invert brightness-200 ${team ? 'opacity-100' : 'opacity-70 group-hover:opacity-100'}`} alt="team" />
<span>Team Management</span>
</div>

<div 
  className={`flex items-center px-4 py-3 rounded-xl cursor-pointer gap-3 transition-all group font-medium ${progressPanel ? 'bg-blue-600 text-white' : 'text-slate-300 hover:bg-slate-800 hover:text-white'}`} 
  onClick={() => { 
    setProgressPanel(true); 
    setTeam(false); 
    setTable(false); 
    setProfile(false); 
    setShow_add_form(false); 
    setClint_open(false); 
    setNewservice(false); 
    setServiceRequests(false); 
    FetchSurveyorProgressUpdates(); 
    setIsSidebarMobileOpen(false); 
  }}
>
  <img src="/images/dashboard.png" className={`w-5 h-5 transition-opacity invert brightness-200 ${progressPanel ? 'opacity-100' : 'opacity-70 group-hover:opacity-100'}`} alt="progress" />
  <span>Project Progress</span>
</div>

</div>
</div>

<div>
<div className="flex items-center gap-3 px-4 py-3 font-medium transition-all cursor-pointer text-rose-400 rounded-xl hover:bg-rose-500/10" onClick={handleLogout}>
<img src="/images/logout.png" className="w-5 h-5 invert sepia hue-rotate-[320deg] saturate-[600%]" alt="logout" />
<span>Logout</span>
</div>
</div>
</div>

{/* --- SIDEBAR BACKDROP FOR OVERLAY ON MOBILE SCREEN --- */}
{isSidebarMobileOpen && (
<div className="fixed inset-0 z-20 transition-opacity bg-slate-900/60 backdrop-blur-sm lg:hidden" onClick={() => setIsSidebarMobileOpen(false)}></div>
)}

<div className="flex flex-col flex-1 min-w-0 transition-all duration-300 lg:ml-72">
{/* --- HEADER WITH NOTIFICATION UI --- */}
<div className="sticky top-0 z-10 flex items-center justify-between w-full h-20 px-6 bg-white border-b shadow-sm border-slate-200/80 backdrop-blur-md">
<div className="flex items-center gap-3">
<button onClick={() => setIsSidebarMobileOpen(true)} className="p-2 -ml-2 transition-colors rounded-xl text-slate-500 hover:bg-slate-100 hover:text-slate-700 lg:hidden">
<img src="images/menu3.png" className="w-6 h-6" alt="menu" />
</button>
<span className="hidden text-lg font-semibold tracking-tight text-slate-800 sm:inline-block">Welcome back, Administrator</span>
</div>

<div className="flex items-center gap-4">
{/* Notification Dropdown Container */}
<div className="relative">
<button 
className="relative p-2.5 transition-colors rounded-xl bg-slate-50 text-slate-600 hover:bg-slate-100 hover:text-slate-900 border border-slate-200"
onClick={() => {
setShowNotifDropdown(!showNotifDropdown);
setUnreadCount(0);
}}
>
<img src="/images/notification.png" className="w-5 h-5 text-slate-600" alt="notif" />
{unreadCount > 0 && (
<span className="absolute -top-1.5 -right-1.5 flex items-center justify-center min-w-[20px] h-5 px-1 text-white bg-rose-500 border-2 border-white rounded-full font-bold text-[10px] animate-pulse">
{unreadCount}
</span>
)}
</button>

{showNotifDropdown && (
<div className="absolute right-0 z-50 mt-3 overflow-hidden transition-all duration-200 origin-top-right transform bg-white border shadow-2xl w-88 border-slate-200 rounded-2xl ring-1 ring-black/5 animate-in fade-in slide-in-from-top-2">
<div className="flex items-center justify-between p-4 text-white bg-slate-950">
<h3 className="text-sm font-semibold">Center Notifications</h3>
<span className="px-2 py-0.5 rounded-full bg-white/20 font-medium text-[11px]">{notifications.length} Unresolved</span>
</div>

<div className="max-h-[350px] overflow-y-auto divide-y divide-slate-100">
{notifications.length > 0 ? (
notifications.map((n, index) => (
<div key={index} onClick={() => {setShowNotifDropdown(false); handleNotificationClick(n.id);}} className="flex items-start gap-3 p-4 transition-colors cursor-pointer hover:bg-slate-50">
<div className={`mt-1 w-2 h-2 rounded-full shrink-0 ${n.type === 'new_message' ? 'bg-emerald-500' : 'bg-blue-500'}`}></div>
<div className="space-y-1">
<p className="text-sm font-medium leading-normal text-slate-700">{n.message}</p>
<span className="inline-block text-[10px] font-bold tracking-wider text-slate-400 uppercase bg-slate-100 px-1.5 py-0.5 rounded">{n.type.replace('_', ' ')}</span>
</div>
</div>
))
) : (
<div className="px-4 py-12 text-center text-slate-400">
<p className="text-sm">Everything is clear right now.</p>
</div>
)}
</div>

{notifications.length > 0 && (
<button 
onClick={() => setNotifications([])}
className="w-full p-3 text-xs font-semibold text-center text-blue-600 transition-colors border-t border-slate-100 hover:bg-slate-50"
>
Clear All Notifications
</button>
)}
</div>
)}
</div>

<div className="relative flex items-center gap-3 pb-2 pl-4 border-l cursor-pointer border-slate-200 group">
{image ? (
<img src={`https://land-survey-project-2.onrender.com/uploads/${image}`} className="object-cover w-10 h-10 rounded-full shadow-inner ring-2 ring-blue-500/20" alt="pfp" />
) : (
<div className="flex items-center justify-center w-10 h-10 border rounded-full bg-slate-100 border-slate-200 text-slate-600">
<img src="/images/profile.png" className="w-5 h-5" alt="pfp" />
</div>
)}
<span className="hidden text-sm font-semibold text-slate-700 md:inline-block">{name}</span>
{/* Add this block right beneath your <span>{name}</span> */}
<div className="absolute right-0 hidden w-48 overflow-hidden bg-white border shadow-xl top-[100%] mt-1 border-slate-200 rounded-xl z-50 group-hover:block">
  
  {/* Profile Link Button */}
  <div 
    onClick={() => { 
      setProfile(true); 
      setShow_add_form(false); 
      setTable(false); 
      setTeam(false); 
      setClint_open(false); 
      setNewservice(false); 
      setServiceRequests(false); 
      setProgressPanel(false)
    }} 
    className="flex items-center gap-2 px-4 py-3 text-sm font-medium transition-colors cursor-pointer hover:bg-slate-50 text-slate-700"
  >
    <img src="/images/profile.png" className="w-4 h-4 opacity-70" alt="profile" />
    Edit Profile
  </div>
  
  {/* Logout Link Button */}
  <div 
    onClick={handleLogout} 
    className="flex items-center gap-2 px-4 py-3 text-sm font-medium transition-colors border-t cursor-pointer hover:bg-rose-50 border-slate-100 text-rose-600"
  >
    <img src="/images/logout.png" className="w-4 h-4 invert sepia hue-rotate-[320deg] saturate-[600%]" alt="logout" />
    Logout Account
  </div>

</div>
</div>
</div>
</div>

<div className="flex-1 overflow-y-auto">
{/* Profile Section */}
{Profile && (
<div className="p-6 mx-auto duration-200 max-w-7xl animate-in fade-in">
<div className="max-w-xl mx-auto overflow-hidden bg-white border shadow-xl border-slate-200 rounded-2xl">
<div className="h-24 bg-gradient-to-r from-blue-600 to-indigo-700"></div>
<form className="relative p-8 pt-0 -mt-12 space-y-6" onSubmit={HandleUpdateprofile}>
<div className="flex flex-col items-center mb-6">
{image ? (
<img src={`https://land-survey-project-2.onrender.com/uploads/${image}`} className="object-cover w-24 h-24 bg-white border-4 border-white shadow-md rounded-2xl" alt="preview" />
) : (
<div className="flex items-center justify-center w-24 h-24 border-4 border-white shadow-md rounded-2xl bg-slate-100 text-slate-400">
<span className="text-2xl font-bold">A</span>
</div>
)}
<h2 className="mt-4 text-xl font-bold text-slate-900">Admin Account Profile</h2>
</div>

{error && <div className="p-3 text-sm font-medium text-center border bg-rose-50 text-rose-600 rounded-xl border-rose-100">{error}</div>}

<div className="space-y-4">
<div>
<label className="block mb-1.5 text-xs font-bold tracking-wider text-slate-500 uppercase">Admin Username</label>
<input type="text" placeholder="Admin Name" className="w-full px-4 py-3 text-sm transition-all border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-slate-50/50" onChange={(e) => setName(Filter_input(e.target.value))} />
</div>

<div>
<label className="block mb-1.5 text-xs font-bold tracking-wider text-slate-500 uppercase">Primary Email Address</label>
<input type="email" placeholder="Admin Email" className="w-full px-4 py-3 text-sm transition-all border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-slate-50/50" onChange={(e) => setEmail(Filter_input(e.target.value))} />
</div>

<div>
<label className="block mb-1.5 text-xs font-bold tracking-wider text-slate-500 uppercase">Update Account Password</label>
<input type="password" placeholder="••••••••••••" className="w-full px-4 py-3 text-sm transition-all border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-slate-50/50" onChange={(e) => setPassword(Filter_input(e.target.value))} />
</div>

<div>
<label className="block mb-1.5 text-xs font-bold tracking-wider text-slate-500 uppercase">Profile Picture Upload</label>
<div className="relative flex justify-center px-6 pt-5 pb-6 mt-1 transition-colors border-2 border-dashed cursor-pointer border-slate-200 rounded-xl hover:bg-slate-50">
<div className="space-y-1 text-center">
<svg className="w-8 h-8 mx-auto text-slate-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true"><path d="M28 8H12a4 4 0 00-4 4v20a4 4 0 004 4h26a4 4 0 004-4V32M14 22l8 8 12-12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
<div className="flex text-sm text-slate-600">
<span className="relative font-semibold text-blue-600 hover:text-blue-500">Choose a local file</span>
</div>
<p className="text-xs text-slate-400">PNG, JPG, GIF up to 10MB</p>
</div>
<input type="file" className="absolute inset-0 opacity-0 cursor-pointer" onChange={(e) => setImage(e.target.files[0])} />
</div>
</div>

<button className="w-full py-3 px-4 text-white font-semibold bg-blue-600 rounded-xl hover:bg-blue-700 shadow-lg shadow-blue-500/20 transition-all active:scale-[0.98]">Commit Settings Save</button>
</div>
</form>
</div>
</div>
)}

{/* Add Surveyor Form */}
{Show_add_form && (
<div className="p-6 mx-auto duration-200 max-w-7xl animate-in fade-in">
<div className="max-w-xl mx-auto overflow-hidden bg-white border shadow-xl border-slate-200 rounded-2xl">
<div className="flex items-center justify-between p-6 text-white border-b bg-slate-900 border-slate-800">
<div>
<h2 className="text-lg font-bold">Register New Team Surveyor</h2>
<p className="text-xs text-slate-400 mt-0.5">Provision an authenticated credential profile</p>
</div>
<button onClick={() => { setShow_add_form(false); setTable(true); }} className="text-xs font-semibold bg-slate-800 px-3 py-1.5 rounded-lg text-slate-300 hover:text-white transition-colors">Cancel</button>
</div>

<form className="p-8 space-y-5" onSubmit={AddSurveyors}>
{surveyor_error && <div className="p-3 text-sm font-medium text-center border bg-rose-50 text-rose-600 rounded-xl border-rose-100">{surveyor_error}</div>}

<div className="grid grid-cols-1 gap-4">
<div>
<label className="block mb-1 text-xs font-bold tracking-wider uppercase text-slate-500">Full Name</label>
<input type="text" placeholder="John Doe" className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 text-sm" onChange={(e) => setSurveyor_name(Filter_input(e.target.value))} required />
</div>

<div>
<label className="block mb-1 text-xs font-bold tracking-wider uppercase text-slate-500">Email Address</label>
<input type="email" placeholder="johndoe@agency.com" className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 text-sm" onChange={(e) => setSurveyor_email(Filter_input(e.target.value))} required />
</div>

<div>
<label className="block mb-1 text-xs font-bold tracking-wider uppercase text-slate-500">Phone Number</label>
<input type="tel" placeholder="+1 (555) 000-0000" className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 text-sm" onChange={(e) => setSurveyor_phone(Filter_input(e.target.value))} required />
</div>

<div>
<label className="block mb-1 text-xs font-bold tracking-wider uppercase text-slate-500">Account Secret Password</label>
<input type="password" placeholder="••••••••••••" className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 text-sm" onChange={(e) => setSurveyor_password(Filter_input(e.target.value))} required />
</div>

<div>
<label className="block mb-1 text-xs font-bold tracking-wider uppercase text-slate-500">Surveyor Avatar Photo</label>
<div className="flex items-center justify-center w-full mt-1">
<label className="flex flex-col items-center justify-center w-full transition-colors border-2 border-dashed cursor-pointer h-28 border-slate-200 rounded-xl bg-slate-50/50 hover:bg-slate-50">
<div className="flex flex-col items-center justify-center pt-5 pb-6">
<svg className="w-6 h-6 mb-2 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4"></path></svg>
<p className="text-xs font-semibold text-slate-500">Click to select photo</p>
</div>
<input type="file" className="hidden" onChange={(e) => setSurveyor_image(e.target.files[0])} required />
</label>
</div>
</div>
</div>

<button className="w-full py-3 px-4 mt-2 text-white font-semibold bg-emerald-600 rounded-xl hover:bg-emerald-700 shadow-lg shadow-emerald-500/20 transition-all active:scale-[0.98]">Establish Team Member</button>
</form>
</div>
</div>
)}

{/* Surveyor Table */}
{table && (
<div className="p-6 mx-auto duration-200 max-w-7xl animate-in fade-in">
<div className="overflow-hidden bg-white border shadow-sm border-slate-200 rounded-2xl">
<div className="flex flex-col justify-between gap-4 p-6 border-b border-slate-200 sm:flex-row sm:items-center">
<div>
<h3 className="text-lg font-bold text-slate-900">Surveyor Management</h3>
<p className="text-xs text-slate-500 mt-0.5">Control corporate user access profiles</p>
</div>
<button className="inline-flex items-center self-start justify-center px-4 py-2 text-sm font-semibold text-white transition-all shadow-sm bg-emerald-600 rounded-xl sm:self-auto hover:bg-emerald-700 active:scale-95" onClick={() => { setTable(false); setShow_add_form(true); setProgressPanel(false);}}>
<svg className="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4"></path></svg>
Add New Surveyor
</button>
</div>
<div className="overflow-x-auto">
<table className="w-full text-left border-collapse">
<thead>
<tr className="text-xs font-bold tracking-wider uppercase border-b text-slate-400 bg-slate-50 border-slate-200">
<th className="px-6 py-3.5">Surveyor Operator</th>
<th className="px-6 py-3.5">Registered Email</th>
<th className="px-6 py-3.5 text-right">Actions Dashboard</th>
</tr>
</thead>
<tbody className="text-sm divide-y divide-slate-100">
{surveyor.map(s => (
<tr className="transition-colors hover:bg-slate-50/70" key={s.member_id}>
<td className="px-6 py-4 font-semibold text-slate-900">{s.member_name}</td>
<td className="px-6 py-4 text-slate-600">{s.member_email}</td>
<td className="px-6 py-4 text-right">
<button className="text-xs font-semibold text-rose-600 bg-rose-50 hover:bg-rose-100 px-3 py-1.5 rounded-lg transition-colors" onClick={() => DeleteSurveyor(s)}>Remove Profile</button>
</td>
</tr>
))}
{surveyor.length === 0 && (
<tr>
<td colSpan="3" className="py-10 text-sm text-center text-slate-400">No surveyors configured on this grid dashboard.</td>
</tr>
)}
</tbody>
</table>
</div>
</div>
</div>
)}

{/* Client Management */}
{client_open && (
<div className="p-6 mx-auto duration-200 max-w-7xl animate-in fade-in">
<div className="overflow-hidden bg-white border shadow-sm border-slate-200 rounded-2xl">
<div className="p-6 border-b border-slate-200">
<h3 className="text-lg font-bold text-slate-900">Client Directory Grid</h3>
<p className="text-xs text-slate-500 mt-0.5">Manage customer parameters and interaction feedback</p>
</div>
<div className="overflow-x-auto">
<table className="w-full text-left border-collapse">
<thead>
<tr className="text-xs font-bold tracking-wider uppercase border-b text-slate-400 bg-slate-50 border-slate-200">
<th className="px-6 py-3.5">Client Profile</th>
<th className="px-6 py-3.5">Email Address</th>
<th className="px-6 py-3.5 text-right">Operation Handlers</th>
</tr>
</thead>
<tbody className="text-sm divide-y divide-slate-100">
{clients.map(c => (
<tr key={c.customer_id} className="transition-colors hover:bg-slate-50/70">
<td className="px-6 py-4 font-semibold text-slate-900">{c.customer_name}</td>
<td className="px-6 py-4 text-slate-600">{c.customer_email}</td>
<td className="px-6 py-4 text-right">
<button className="text-xs font-semibold text-blue-600 bg-blue-50 hover:bg-blue-100 px-3 py-1.5 rounded-lg transition-colors" onClick={() => { setSelectedClient(c); setViewClientModal(true); setProgressPanel(false);}}>Inspect Inquiry</button>
</td>
</tr>
))}
{clients.length === 0 && (
<tr>
<td colSpan="3" className="py-10 text-sm text-center text-slate-400">No registered client records detected.</td>
</tr>
)}
</tbody>
</table>
</div>
</div>

{view_client_modal && selectedClient && (
<div className="fixed inset-0 z-50 flex items-center justify-center p-4 duration-200 bg-slate-900/40 backdrop-blur-sm animate-in fade-in">
<div className="w-full max-w-xl overflow-hidden bg-white shadow-2xl rounded-2xl border border-slate-200/60 flex flex-col max-h-[90vh]">
<div className="flex items-center justify-between p-6 text-white bg-slate-950">
<div>
<h3 className="text-lg font-bold">Inquiry Management Console</h3>
<p className="text-xs text-slate-400 mt-0.5">Direct link channels with consumers</p>
</div>
<button onClick={() => setViewClientModal(false)} className="p-1 text-2xl font-light leading-none transition-colors rounded-lg text-slate-400 hover:bg-slate-800 hover:text-white">&times;</button>
</div>
<div className="flex-1 p-6 space-y-5 overflow-y-auto">
<div>
<span className="text-[10px] font-bold tracking-wider text-slate-400 uppercase block mb-1">Customer Target Address</span>
<p className="text-sm font-semibold text-slate-800">{selectedClient.customer_name} <span className="font-normal text-slate-500">({selectedClient.customer_email})</span></p>
</div>
<div>
<span className="text-[10px] font-bold tracking-wider text-slate-400 uppercase block mb-1.5">Communication Vault Stream</span>
<div className="space-y-2.5 max-h-[200px] overflow-y-auto pr-1">
{chatHistoryClient.length > 0 && chatHistoryClient.filter(u => u.senderId === selectedClient.customer_id).length > 0 ? (
chatHistoryClient.filter(u => u.senderId === selectedClient.customer_id).map((m, i) => (
<div className="p-4 text-sm border shadow-inner text-slate-700 border-slate-100 rounded-xl bg-slate-50" key={i}>
{m.client_message}
</div>
))
) : (
<div className="p-4 text-sm italic text-center border border-dashed text-slate-400 border-slate-100 rounded-xl bg-slate-50/50">
No logged historical statement files linked to this ID.
</div>
)}
</div>
</div>
<div className="pt-4 border-t border-slate-100">
<label className="block mb-1.5 text-xs font-bold tracking-wider text-slate-400 uppercase">Draft Feedback Response</label>
<textarea
className="w-full p-3.5 border border-slate-200 rounded-xl outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 text-sm transition-all"
rows="3"
placeholder="Formulate professional email dispatch reply..."
value={clientFeedback}
onChange={(e) => setClientFeedback(e.target.value)}
/>
</div>
</div>
<div className="flex items-center justify-end gap-3 p-4 border-t bg-slate-50 border-slate-100">
<button onClick={() => setViewClientModal(false)} className="px-4 py-2 text-sm font-semibold transition-colors text-slate-600 hover:text-slate-800">Dismiss View</button>
<button onClick={sendFeedBack} className="px-5 py-2 text-sm font-semibold text-white transition-all bg-blue-600 shadow-sm rounded-xl hover:bg-blue-700 active:scale-95">Dispatch Reply Connection</button>
</div>
</div>
</div>
)}
</div>
)}

{/* Incoming Service Requests */}
{serviceRequests && (
<div className="p-6 mx-auto duration-200 max-w-7xl animate-in fade-in">
<div className="overflow-hidden bg-white border shadow-sm border-slate-200 rounded-2xl">
<div className="p-6 border-b border-slate-200">
<h3 className="text-lg font-bold text-slate-900">Incoming Project Requests</h3>
<p className="text-xs text-slate-500 mt-0.5">Pending client operations and field submission protocols</p>
</div>
<div className="overflow-x-auto">
<table className="w-full text-left border-collapse">
<thead>
<tr className="text-xs font-bold tracking-wider uppercase border-b text-slate-400 bg-slate-50 border-slate-200">
<th className="px-6 py-3.5">Client Consumer Name</th>
<th className="px-6 py-3.5">Requested Target Module</th>
<th className="px-6 py-3.5 text-right">Administrative Operations</th>
</tr>
</thead>
<tbody className="text-sm divide-y divide-slate-100">
{requests && (
requests.map(req => (
<tr key={req.submission_id} className="transition-colors hover:bg-slate-50/70">
<td className="px-6 py-4 font-semibold text-slate-900">{req.formsubmit["Full Name"]}</td>
<td className="px-6 py-4 font-medium text-blue-600">{req.service_name}</td>
<td className="px-6 py-4 text-right">
<div className="flex items-center justify-end gap-2">
<button className="text-xs font-semibold text-blue-600 bg-blue-50 hover:bg-blue-100 px-3 py-1.5 rounded-lg transition-colors" onClick={() => { setSelectedRequest(req); setViewRequestModal(true); }}>Review Payload</button>
<button className="text-xs font-semibold text-rose-600 bg-rose-50 hover:bg-rose-100 px-3 py-1.5 rounded-lg transition-colors" onClick={() => DeleteServiceRequest(req.submission_id)}>Purge Link</button>
</div>
</td>
</tr>
))
)}

{!requests && (
<tr>
<td colSpan="3" className="py-10 text-sm text-center text-slate-400">No incoming project parameters file vectors pending validation.</td>
</tr>
)}
</tbody>
</table>
</div>
</div>

{viewRequestModal && selectedRequest && (
<div className="fixed inset-0 z-50 flex items-center justify-center p-4 duration-200 bg-slate-900/40 backdrop-blur-sm animate-in fade-in">
<div className="w-full max-w-xl overflow-hidden bg-white shadow-2xl rounded-2xl border border-slate-200 flex flex-col max-h-[90vh]">
<div className="flex items-center justify-between p-6 text-white bg-slate-950">
<div>
<h3 className="text-lg font-bold">{selectedRequest.service_name} Deployment Payload</h3>
<p className="text-xs text-slate-400 mt-0.5">Comprehensive structural property forms dataset</p>
</div>
<button onClick={() => setViewRequestModal(false)} className="p-1 text-2xl font-light leading-none transition-colors rounded-lg text-slate-400 hover:bg-slate-800 hover:text-white">&times;</button>
</div>
<div className="flex-1 p-6 space-y-4 overflow-y-auto">
{Object.entries(selectedRequest.formsubmit).map(([key, value]) => (
<div key={key} className="p-3.5 border border-slate-100 rounded-xl bg-slate-50/60">
<span className="text-[10px] font-bold tracking-wider text-slate-400 uppercase block mb-1">{key.replace(/_/g, ' ')}</span>
<div className="text-sm font-semibold text-slate-800">
{typeof value === 'string' && value.match(/\.(jpg|jpeg|png|pdf|docx)$/i) ? (
<a href={`https://land-survey-main-server.onrender.com/documentUploaded/${value}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-blue-600 hover:underline">
<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>
View Digital Payload Asset Doc
</a>
) : (
value || <span className="italic font-normal text-slate-400">Undefined Vector Parameter</span>
)}
</div>
</div>
))}
</div>
<div className="flex items-center justify-between gap-3 p-4 border-t bg-slate-50 border-slate-100">
<button onClick={() => DeleteServiceRequest(selectedRequest.submission_id)} className="px-4 py-2 text-sm font-semibold text-white transition-all shadow-sm bg-rose-600 hover:bg-rose-700 rounded-xl active:scale-95">Purge Request permanently</button>
<button onClick={() => setViewRequestModal(false)} className="px-4 py-2 text-sm font-semibold transition-colors text-slate-600 hover:text-slate-800">Dismiss Details View</button>
</div>
</div>
</div>
)}
</div>
)}

{/* Project Progress Page */}
{progressPanel && (
  <div className="p-6 mx-auto max-w-7xl">
    <div className="overflow-hidden bg-white border border-gray-200 shadow-sm rounded-xl">
      
      {/* Header */}
      <div className="p-6 text-white bg-gray-900">
        <h3 className="text-lg font-bold">Surveyor Progress Tracking</h3>
        <p className="mt-1 text-xs text-gray-400">
          Review, approve, or delete updates sent by your surveyors from the field.
        </p>
      </div>

      {/* Table Area */}
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="text-xs font-bold text-gray-400 uppercase border-b border-gray-200 bg-gray-50">
              <th className="px-6 py-3">Project Info</th>
              <th className="px-6 py-3">Surveyor Update Notes</th>
              <th className="px-6 py-3">Progress Bar</th>
              <th className="px-6 py-3 text-right">Actions</th>
            </tr>
          </thead>
          <tbody className="text-sm divide-y divide-gray-100">
            {surveyorProgressUpdates.map((item) => (
              <tr key={item.progress_id} className="hover:bg-gray-50">
                
                {/* Project Name and IDs */}
                <td className="px-6 py-4">
                  <span className="block font-bold text-gray-900">{item.project_name}</span>
                  <span className="text-[11px] text-gray-400">
                    Project ID: #{item.project_id} / Update ID: #{item.progress_id}
                  </span>
                </td>

                {/* Progress Title and Text */}
                <td className="px-6 py-4">
                  <span className="block font-semibold text-gray-700">{item.progress_title}</span>
                  <p className="max-w-md mt-1 text-xs text-gray-500">
                    {item.progress_deep_summary}
                  </p>
                </td>

                {/* Loading/Percentage Bar */}
                <td className="px-6 py-4">
                  <div className="flex items-center w-40 gap-3">
                    <div className="w-full h-2 overflow-hidden bg-gray-100 border border-gray-200 rounded-full">
                      <div 
                        className="h-full transition-all duration-300 bg-blue-600 rounded-full" 
                        style={{ width: `${item.progress_percentage}%` }}
                      ></div>
                    </div>
                    <span className="text-xs font-bold text-gray-600">
                      {item.progress_percentage}%
                    </span>
                  </div>
                </td>

                {/* Action Buttons */}
                <td className="px-6 py-4 space-x-2 text-right whitespace-nowrap">
                  <button 
                    onClick={() => handleApproveProgress(item.progress_id)} 
                    className="text-xs font-semibold bg-green-50 text-green-600 hover:bg-green-100 px-3 py-1.5 rounded-lg"
                  >
                    Send to Client
                  </button>
                  <button 
                    onClick={() => handleDeleteProgressUpdate(item.progress_id)} 
                    className="text-xs font-semibold bg-gray-100 text-gray-600 hover:bg-gray-200 px-3 py-1.5 rounded-lg"
                  >
                    Delete Update
                  </button>
                </td>

              </tr>
            ))}

            {/* If there are no updates */}
            {surveyorProgressUpdates.length === 0 && (
              <tr>
                <td colSpan="4" className="py-12 text-center text-gray-400">
                  No progress updates found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

    </div>
  </div>
)}

{team && (
<div className="flex flex-col md:flex-row h-[calc(100vh-80px)] bg-slate-50 overflow-hidden animate-in fade-in duration-200">
<div className="flex flex-col w-full bg-white border-b md:border-b-0 md:border-r border-slate-200 md:w-80 h-1/2 md:h-full shrink-0">
<div className="p-4 border-b border-slate-200 bg-slate-50/50"><h3 className="text-sm font-bold text-slate-900">Active Surveyor Operators</h3></div>
<div className="flex-1 overflow-y-auto divide-y divide-slate-100">
{surveyor.map((m) => (
<div key={m.member_id} onClick={() => setSelectedMember(m)} className={`flex items-center gap-3 p-4 cursor-pointer transition-all ${selectedMember?.member_id === m.member_id ? 'bg-blue-50/70 border-l-4 border-l-blue-600' : 'hover:bg-slate-50/50'}`}>
{m.member_image ? (
<img src={`https://land-survey-project-2.onrender.com/surveyors_images/${m.member_image}`} className="object-cover w-10 h-10 bg-white border shadow-sm border-slate-200 rounded-xl" alt="m" />
) : (
<div className="flex items-center justify-center w-10 h-10 text-sm font-bold border rounded-xl bg-slate-100 border-slate-200 text-slate-400">S</div>
)}
<div className="flex-1 min-w-0">
<p className="text-sm font-semibold truncate text-slate-800">{m.member_name}</p>
<p className="text-[10px] font-bold tracking-wider text-slate-400 uppercase mt-0.5">Field Agent</p>
</div>
</div>
))}
{surveyor.length === 0 && <div className="p-6 text-xs text-center text-slate-400">No surveyor team channels initialized.</div>}
</div>
</div>

<div className="flex flex-col flex-1 h-1/2 md:h-full bg-slate-100">
{selectedMember ? (
<>
<div className="z-10 flex items-center gap-3 p-4 bg-white border-b shadow-sm border-slate-200 shrink-0">
{selectedMember.member_image ? (
<img src={`https://land-survey-project-2.onrender.com/surveyors_images/${selectedMember.member_image}`} className="object-cover border shadow-sm w-9 h-9 border-slate-200 rounded-xl" alt="h" />
) : (
<div className="flex items-center justify-center text-xs font-bold border w-9 h-9 rounded-xl bg-slate-100 border-slate-200 text-slate-400">S</div>
)}
<h4 className="text-sm font-bold text-slate-800">{selectedMember.member_name}</h4>
</div>
<div className="flex flex-col flex-1 gap-3 p-6 overflow-y-auto">
{chatHistory.filter(id => id.senderId === selectedMember.member_id || id.surveyorId === selectedMember.member_id).map((m, i) => (
<div className={`p-3.5 rounded-2xl text-sm max-w-md shadow-sm border ${m.sender === 'admin' ? 'bg-blue-600 border-blue-700 text-white self-end rounded-tr-none' : 'bg-white border-slate-200/60 text-slate-800 self-start rounded-tl-none'}`} key={i}>
{m.sender === 'admin' ? m.message : m.report}
</div>
))}
</div>
<div className="flex items-center gap-3 p-4 bg-white border-t border-slate-200 shrink-0">
<input type="text" value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Formulate internal tactical response message..." className="flex-1 px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 text-sm" onKeyPress={(e) => e.key === 'Enter' && SendMessage()} />
<button className="px-5 py-2.5 text-sm font-semibold text-white bg-blue-600 rounded-xl hover:bg-blue-700 shadow-sm transition-all active:scale-95" onClick={SendMessage}>Transmit</button>
</div>
</>
) : (
<div className="flex flex-col items-center justify-center flex-1 gap-2 p-6 text-slate-400">
<svg className="w-8 h-8 text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"></path></svg>
<p className="text-sm font-medium">Select a team channel node from the log terminal grid list to initiate session parameters.</p>
</div>
)}
</div>
</div>
)}

{Newservice && (
<div className="max-w-3xl p-6 mx-auto my-8 duration-200 animate-in fade-in">
<div className="overflow-hidden bg-white border shadow-xl border-slate-200 rounded-2xl">
<div className="p-6 text-white border-b bg-slate-900 border-slate-800">
<h2 className="text-lg font-bold">Construct New Product Category Node</h2>
<p className="text-xs text-slate-400 mt-0.5">Deploy customized field schema questionnaires variables to system platform core</p>
</div>
<form className="p-8 space-y-6" onSubmit={(e) => { e.preventDefault(); AddService(); }}>
<div className="grid grid-cols-1 gap-5 md:grid-cols-2">
<div className="md:col-span-2">
<label className="block mb-1.5 text-xs font-bold tracking-wider text-slate-500 uppercase">Service Engine Identity Designation Name</label>
<input type="text" value={serviceName} onChange={(e) => setServiceName(e.target.value)} placeholder="e.g. Hydrographic Boundary Survey" className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 text-sm" />
</div>
<div className="md:col-span-2">
<label className="block mb-1.5 text-xs font-bold tracking-wider text-slate-500 uppercase">Product Scope Description Log Matrix</label>
<textarea value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Detail structural boundaries parameters..." className="w-full h-24 px-4 py-3 text-sm border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500" />
</div>
<div className="md:col-span-2">
<label className="block mb-1.5 text-xs font-bold tracking-wider text-slate-500 uppercase">Product Categorization Graphical Banner Image</label>
<label className="flex items-center justify-center w-full text-sm font-semibold transition-colors border border-dashed cursor-pointer h-11 text-slate-700 bg-slate-50 border-slate-200 rounded-xl hover:bg-slate-100">
{serviceImage ? serviceImage.name : "Upload File Asset Node"}
<input type="file" hidden onChange={(e) => setServiceImage(e.target.files[0])} />
</label>
</div>
</div>

<div className="pt-4 border-t border-slate-200">
<div className="flex items-center gap-2 mb-4">
<div className="w-1.5 h-5 bg-blue-600 rounded-full"></div>
<span className="text-sm font-bold text-slate-900">Dynamic Input Form Fields Generator Matrix</span>
</div>
<div className="space-y-4">
{Questions.map((q, i) => (
<div key={i} className="relative p-4 space-y-3 duration-150 border border-slate-200 rounded-xl bg-slate-50/50 group animate-in slide-in-from-bottom-2">
<div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
<div className="sm:col-span-2">
<input type="text" onChange={(e) => UpdateQuestions(i, "text", e.target.value)} value={q.text} placeholder={q.type === "Option" ? "Enter Configuration Selection Title Label" : "Field Input Descriptor Label Text..."} className={`w-full px-3 h-10 border rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 bg-white ${q.type === 'Option' ? 'border-blue-500 shadow-sm' : 'border-slate-200'}`} />
</div>
<div>
<select onChange={(e) => UpdateQuestions(i, "type", e.target.value)} value={q.type} className="w-full h-10 px-3 text-sm bg-white border border-slate-200 rounded-xl focus:outline-none">
<option value="Text">Plain Text Line</option>
<option value="Email">Secure Email Channel</option>
<option value="File">Document File Asset</option>
<option value="Number">Telephone Digits</option>
<option value="Option">Multiple Choice Options</option>
<option value="Description">Paragraph Description Box</option>
</select>
</div>
</div>
<div className="flex flex-col items-stretch justify-between gap-3 sm:flex-row sm:items-center">
<input type="text" placeholder="Form input field guidelines placeholder prompt..." className="flex-1 h-10 px-3 text-sm bg-white border border-slate-200 rounded-xl focus:outline-none" onChange={(e) => UpdateQuestions(i, 'placeholder', e.target.value)} />
<div className="flex items-center justify-between gap-4 px-1 sm:justify-start">
<label className="flex items-center cursor-pointer select-none">
<input type="checkbox" className="w-4 h-4 text-blue-600 rounded border-slate-200 focus:ring-blue-500" onChange={(e) => UpdateQuestions(i, 'required', e.target.checked)} />
<span className="ml-2 text-xs font-semibold text-slate-600">Enforce Validation</span>
</label>
</div>
</div>
{q.type === "Option" && (
<div className="pl-4 mt-2 space-y-2 duration-200 border-l-2 border-blue-500 animate-in fade-in">
{q.options.map((opt, j) => (
<div key={j} className="flex items-center gap-2">
<input type="text" value={opt} onChange={(e) => UpdateQuestions(i, "option", e.target.value, j)} placeholder={`Selection Option ${j + 1}`} className="flex-1 px-3 text-xs border rounded-lg h-9 border-slate-200" />
<button type="button" onClick={() => UpdateQuestions(i, "removeOption", null, j)} className="h-9 px-2.5 text-white bg-rose-500 rounded-lg hover:bg-rose-600 text-xs font-bold transition-colors">✕</button>
</div>
))}
<button type="button" onClick={() => UpdateQuestions(i, "addOption")} className="px-3 py-1.5 text-xs font-semibold text-blue-600 bg-blue-50 hover:bg-blue-100 rounded-lg transition-colors">+ Append Array Choice</button>
</div>
)}
</div>
))}
</div>
<button type="button" onClick={AddNewQuestion} className="inline-flex items-center px-3 py-2 mt-2 text-xs font-bold transition-colors rounded-lg text-emerald-600 bg-emerald-50 hover:bg-emerald-100">+ Inject Schema Input Question Node</button>
</div>
<div className="flex justify-end pt-4 border-t border-slate-200">
<button type="submit" className="px-6 py-2.5 text-sm font-semibold text-white bg-blue-600 rounded-xl hover:bg-blue-700 shadow-lg shadow-blue-500/20 transition-all active:scale-[0.98]">Deploy Service Platform Module</button>
</div>
</form>
</div>
</div>
)}
</div>
</div>
</div>
</Fragment>
);
}

export default AdminDash;